require('../bootstrap');

import Vue from 'vue'

import 'babel-polyfill'
import vuetify from '../plugins/vuetify/vuetify'

Vue.use(vuetify);

import ScrollLoader from 'vue-scroll-loader'

Vue.use(ScrollLoader);

import Vuex from 'vuex'
import appStore from './store'

import VueRouter from 'vue-router'
import appRoutes from './routes';

import VuejsClipper from 'vuejs-clipper'
Vue.use(VuejsClipper, {
    components: {
        clipperBasic: true,
        clipperPreview: true,
        clipperFixed: true,
        clipperUpload: true
    }
});

import ProductZoomer from 'vue-product-zoomer'
Vue.use(ProductZoomer);

import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use( CKEditor );

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

// global mixins
import Auth from './mixins/Auth';
import LangManager from '../plugins/lang-manager';
import Meta from './mixins/Meta';
import SeoTexts from './mixins/SeoTexts';

import App from '../views/front/App.vue'


Vue.component(
    'passport-clients',
    require('./components/passport/Clients.vue')
);

Vue.component(
    'passport-authorized-clients',
    require('./components/passport/AuthorizedClients.vue')
);

Vue.component(
    'passport-personal-access-tokens',
    require('./components/passport/PersonalAccessTokens.vue')
);
/**
 * Enable VueRouter
 */
Vue.use(VueRouter);
const router = new VueRouter(appRoutes);

/**
 * Enable Vuex
 */
Vue.use(Vuex);
const store = new Vuex.Store(appStore);

Vue.mixin(LangManager);
Vue.mixin(Meta);
Vue.mixin(SeoTexts);
Vue.mixin(Auth);

router.beforeEach((to, from, next) => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
    next();
});

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app');
